import request from "@/utils/request";

// 删除在线表单模板
export function delOsFormTemplate(funcId) {
  return request({
    url: "delOsFormTemplate?funcId=" + funcId,
    method: "GET",
  });
}

// 在线表单模板数据查询
export function findOsFormReport(params) {
  return request({
    url: "findOsFormReport",
    method: "get",
    params,
  });
}

// 查询在线表单模板
export function findOsFormTemplate(name) {
  return request({
    url: "findOsFormTemplate" + name + "name",
    method: "GET",
  });
}
// 在线表单模板查询/by id
export function findOsFormTemplateInfo(id) {
  return request({
    url: "findOsFormTemplateInfo/" + id,
    method: "get",
  });
}

// 新增/修改在线表单模板
export function saveOsFormTemplate(data) {
  return request({
    url: "saveOsFormTemplate",
    data: data,
    method: "POST",
  });
}

// 在线表单提交
export function saveOsFormReport(data) {
  return request({
    url: "saveOsFormReport",
    data: data,
    method: "POST",
  });
}
